import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "truncate", "useFlex"];
import { TruncateString as FoundationsTruncateString } from 'foundations-components/transitional/components/TruncateString';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const TruncateString = _ref => {
  let {
      children,
      truncate = true,
      useFlex = true
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (!truncate) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  return /*#__PURE__*/_jsx(FoundationsTruncateString, Object.assign({}, rest, {
    useFlex: useFlex,
    children: children
  }));
};